/**
 * Document (DMS) service.
 * Integrated with backend API
 */

import { apiClient } from './apiClient';

/**
 * Get all documents for a specific client
 */
export const getClientDocuments = async (clientId) => {
  try {
    const response = await apiClient.get(`/api/v1/clients/${clientId}/documents`);
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch client documents:', error);
    return [];
  }
};

/**
 * Upload a document for a client
 */
export const uploadDocument = async (clientId, documentName, file) => {
  try {
    const formData = new FormData();
    formData.append('client_id', String(clientId));
    formData.append('document_name', documentName);
    formData.append('file', file);

    const response = await apiClient.post(`/api/v1/documents`, formData);
    return response.data.data;
  } catch (error) {
    console.error('Failed to upload document:', error);
    throw error;
  }
};

/**
 * Download a document
 */
export const downloadDocument = async (documentId, fileName) => {
  try {
    const response = await apiClient.get(
      `/api/v1/documents/${documentId}/download`,
      {
        responseType: 'blob',
      }
    );

    // Create a blob URL and trigger download
    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('Failed to download document:', error);
    throw error;
  }
};

/**
 * Delete a document
 */
export const deleteDocument = async (documentId) => {
  try {
    const response = await apiClient.delete(`/api/v1/documents/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete document:', error);
    throw error;
  }
};
